import React from 'react';
import Select from '../../../../components/Select';
import { languageList } from '../../../code/Prism';
import ToolbarButton from './ToolbarButton';
import styles from './ToolbarSyntaxButton.module.scss';

interface ToolbarSyntaxButtonProps {
  languageKey?: string | null;
  dropdownOpen: boolean;
  onDropdownOpenChange: (open: boolean) => void;
  onSelect: (key: string) => void;
}

const ToolbarSyntaxButton = ({
  languageKey = 'plain',
  dropdownOpen,
  onDropdownOpenChange,
  onSelect,
}: ToolbarSyntaxButtonProps) => {
  const currentLanguage =
    languageKey && languageList.find(({ key }) => key === languageKey);

  return (
    <ToolbarButton
      rightAlignPopOver
      // eslint-disable-next-line react/no-unstable-nested-components -- Fix next time editing the file
      popOver={(onClose) => (
        <div className={styles.container}>
          <Select
            autoFocus
            menuIsOpen
            disableMenuPortal
            components={{
              DropdownIndicator: null,
            }}
            controlShouldRenderValue={false}
            hideSelectedOptions={false}
            isClearable={false}
            backspaceRemovesValue={false}
            value={languageKey}
            onChange={(key) => {
              onSelect(key);
              onClose();
            }}
            placeholder="Search for languages..."
            options={languageList.map(({ key, label }) => ({
              label,
              value: key,
            }))}
          />
        </div>
      )}
      popOverOpen={dropdownOpen}
      onPopOverOpenChange={onDropdownOpenChange}
    >
      {currentLanguage ? currentLanguage.label : 'Plain'}
    </ToolbarButton>
  );
};

export default ToolbarSyntaxButton;
